import { goToErrorsView } from 'actions/errorViewNavigation';

require('./profileSteps.scss');
// @ vendors
const React = require('react');
const { bindActionCreators } = require('redux');
const { connect } = require('react-redux');
// @ components
import { RoadmapNavigation } from 'components/steps/RoadmapNavigation/RoadmapNavigation';
const { HomeAbroadConfigCard } = require('routes/formsView/homeAbroadConfigCard');
// @ actions
const stepsActions = require('actions/stepsActions');
const formActions = require('react-redux-form').actions;
// @const
const { FIXED_PAYMENT_METHOD_VALUE, VARIABLE_PAYMENT_METHOD_VALUE } = require('utilities/paymentMethodHelper');

class ProfileConfigCard extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isClicked: false,
        };

        this.onHandleContinue = this.onHandleContinue.bind(this);
        this.gotoNextStep = this.gotoNextStep.bind(this);
        this.getRequiredFields = this.getRequiredFields.bind(this);
        this.onHandleValidateFields = this.onHandleValidateFields.bind(this);
    }

    UNSAFE_componentWillMount() {
        window.scrollTo(0, 0);
    }

    componentWillUnmount() {
        const { userProfile, formActions } = this.props;
        if (userProfile.openCredit) {
            formActions.resetValidity('userProfile.paymentMethodType');
            formActions.resetValidity('userProfile.fixedPaymentMethodValue');
            formActions.resetValidity('userProfile.variablePaymentMethodValue');
            formActions.resetValidity('userProfile.openCreditCardSelectedCode');
        } else {
            formActions.resetValidity('userProfile.homeAbroadCardSelectedCode');
        }
    }

    gotoNextStep() {
        const { actions, immStepsState } = this.props;
        const currentIndex = immStepsState.get('currentStep');
        const disabled = this.props.immStepsState.get('readOnlyForms');

        this.setState({ isClicked: false });

        if (!disabled) {
            actions.finalizeStep({
                index: currentIndex,
                finished: true,
            });
            actions.enableFinishedAndNextStep();
            actions.changeCurrentStep({
                index: currentIndex + 1,
            });
        } else {
            actions.changeCurrentStep({
                index: currentIndex + 1,
            });
        }
    }

    getRequiredFields() {
        const { userProfile } = this.props;
        let requiredFields = [];

        if (userProfile.openCredit) {
            const paymentMethodType = userProfile.paymentMethodType;
            requiredFields = requiredFields.concat(['openCreditCardSelectedCode']);
            requiredFields = requiredFields.concat(['paymentMethodType']);

            switch (paymentMethodType) {
                case FIXED_PAYMENT_METHOD_VALUE:
                    requiredFields = requiredFields.concat(['fixedPaymentMethodValue']);
                    break;
                case VARIABLE_PAYMENT_METHOD_VALUE:
                    requiredFields = requiredFields.concat(['variablePaymentMethodValue']);
                    break;
                default:
                    break;
            }
        } else {
            requiredFields = requiredFields.concat(['homeAbroadCardSelectedCode']);
        }

        return requiredFields;
    }

    onHandleValidateFields() {
        const { userProfile, formActions } = this.props;
        let requiredFlag = true;
        let fieldsWithError = '';
        let j = 0;
        const disabled = this.props.immStepsState.get('readOnlyForms');
        if (!disabled) {
            const requiredFields = this.getRequiredFields();
            // Parse validations
            for (let i = 0; i < requiredFields.length; i++) {
                const field = userProfile[requiredFields[i]];
                if (field === '' || typeof field === 'undefined' || field === null) {
                    if (j == 0) {
                        fieldsWithError += requiredFields[i];
                    } else {
                        fieldsWithError += `|${requiredFields[i]}`;
                    }
                    j++;
                    formActions.setValidity(`userProfile.${requiredFields[i]}`, { required: false });
                    requiredFlag = false;
                }
            }
        }

        return requiredFlag;
    }

    onHandleContinue() {
        const { userProfile, actions, goToErrorsView } = this.props;
        const accessToken = userProfile.accessToken;
        const disabled = this.props.immStepsState.get('readOnlyForms');
        const valid = this.onHandleValidateFields();

        this.setState({ isClicked: true });

        if (valid && !disabled) {
            actions.clientVerifyOk(accessToken, (verifiedOk, errors) => {
                if (verifiedOk) {
                    this.gotoNextStep();
                } else {
                    if (errors['6002']) {
                        goToErrorsView({ errorCode: 6002 });
                    }
                    this.setState({ isClicked: false });
                }
            });
        } else if (disabled) {
            this.gotoNextStep();
        } else {
            this.setState({ isClicked: false });
        }
    }

    render() {
        return (
            <div>
                <HomeAbroadConfigCard />
                <div className="row form__footer">
                    <div className="col-lg-12">
                        <RoadmapNavigation
                            buttonContinueAction={this.onHandleContinue}
                            buttonContinueDisabled={this.state.isClicked}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

module.exports.constructor = ProfileConfigCard;
module.exports.ProfileConfigCard = connect(
    state => ({
        userProfile: state.userProfile,
        immStepsState: state.steps,
    }),
    dispatch => ({
        actions: bindActionCreators(stepsActions, dispatch),
        formActions: bindActionCreators(formActions, dispatch),
        goToErrorsView: bindActionCreators(goToErrorsView, dispatch),
    })
)(ProfileConfigCard);
